import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule, NgxUiLoaderRouterModule, NgxUiLoaderConfig, SPINNER, PB_DIRECTION } from 'ngx-ui-loader';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { NgxCoolDialogsModule } from 'ngx-cool-dialogs';

import { PipeModule } from './pipe/pipe.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { ModalModule } from 'ngx-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateLoader } from './translate.config';
import { HttpClient } from '@angular/common/http';
import { ToastProvider } from './providers/toast/toast';
import { Toaster, ToastNotificationsModule } from 'ngx-toast-notifications';
import { AlertsProvider } from './providers/alerts/alerts.provider';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { TranslationInitService } from './services/utilitys/utilitys.service';



// import { ModalCompletedComponent } from './components/modal/modal-completed/modal-completed.component';
// import { WaitingPageComponent } from './components/waiting-page/waiting-page.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#4A51B4',//document.documentElement.style.getPropertyPriority('--app-primary') ,//
  bgsSize: 40,
  bgsType: SPINNER.rectangleBounce, // background spinner type
  fgsType: SPINNER.rectangleBounce, // foreground spinner type
  fgsColor: '#4A51B4', //document.documentElement.style.getPropertyPriority('--app-primary') ,
  fgsSize: 40,
  pbColor: '#4A51B4', //document.documentElement.style.getPropertyPriority('--app-primary') ,
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 3, // progress bar thickness,
};

export function initApp(translationInit: TranslationInitService) {
  return () => translationInit.initTranslation();
}
@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    ModalModule.forRoot(),
    NgbModule,
    RouterModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule,
    DeviceDetectorModule.forRoot(),
    PipeModule,
    NgxCoolDialogsModule.forRoot(),
    NgxPaginationModule,
    ToastNotificationsModule.forRoot(),
    FilterPipeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    } ),
  ],
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    VideoPlayerComponent
  ],
  providers: [
    ToastProvider,
    Toaster,
    AlertsProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [TranslationInitService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
